import Box from "./Box";
import Checkbox from "./Checkbox";
import PropTypes from "prop-types";
import React from "react";
import { useListingsContext } from "./ListingsContext";

function FilterGroup({ type, options }) {
  const { activeFilters, setFilter, clearFiltersOfType } = useListingsContext();
  const activeFiltersForType = activeFilters.find((filter) => {
    return filter.type === type;
  }) || { options: [] };

  return (
    <Box>
      <Box pb="5px">
        <Checkbox
          active={activeFiltersForType.options.length === 0}
          label="All"
          onClick={() => {
            clearFiltersOfType(type);
          }}
        />
      </Box>
      {options.map((option) => {
        const active = activeFiltersForType.options.find((activeOption) => {
          return activeOption.value == option.value;
        });
        return (
          <Box key={`${option.key}-${option.label}-${option.value}`} pb="5px">
            <Checkbox
              active={typeof active === "undefined" ? false : true}
              label={option.label}
              onClick={() => {
                setFilter(type, option);
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
}

export default FilterGroup;

FilterGroup.propTypes = {
  type: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
    })
  ),
};
